import { useEffect, type ReactElement } from 'react';
import useCanScroll from 'hooks/use-can-scroll';
import styles from './scrollable-container.module.scss';

export function ScrollableContainer({ children }: ScrollableContainerProps) {
	const { canScroll, scrollableElRef, recalculate } = useCanScroll();

	// We force a recalculation of scrollability rather than relying on height changes
	// triggering it automatically because different children may not change the height
	// in our specific use case.
	useEffect(() => {
		const el = scrollableElRef.current;
		if (!el) return;

		el.scrollTo({ top: 0, left: 0, behavior: 'instant' });
		recalculate();
	}, [children, recalculate, scrollableElRef]);

	return (
		<div
			className={[
				styles.scrollableContentWrapper,
				canScroll.down ? styles.canScrollDown : '',
				canScroll.up ? styles.canScrollUp : '',
			].join(' ')}
		>
			<div ref={scrollableElRef} className={styles.scrollableContent}>
				{children}
			</div>
		</div>
	);
}

interface ScrollableContainerProps {
	children: ReactElement;
}
